import { Route } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";
import { HasChildGuard } from "./guards/has-child-guard";
import LayoutPage from "./pages/layout/layout.page";
import MyChildLayout from "./pages/my-child/my-child.layout";
import MyPageLayoutPage from "./pages/my-page/layout/layout.page";

export const appRoutes: Route[] = [
    {
        path: "",
        pathMatch: "full",
        // loadding -> 개발 중 login 으로 대체
        redirectTo: "login",
    },
    // http://localhost:4200/charge/point/payment?success=true&successId=&lPInspectionType=&childId=&centerId=&baseAmount=1000&productName=%ED%8F%AC%EC%9D%B8%ED%8A%B8%201000P&paymentType=NORMAL&orderId=order-1761649446786&paymentKey=tmali20251028200403uDHX1&amount=1000

    // 선생님 일정 경로가 고정되어 있으므로 임시 처리
    {
        path: "child",
        children: [
            {
                path: ":developmentServiceId",
                children: [
                    {
                        path: "detail/:childId",
                        loadComponent: () =>
                            import("./pages/switch-child/switch-child.page"),
                    },
                ],
            },
        ],
    },
    {
        path: "term",
        children: [
            {
                path: ":value",
                loadComponent: () => import("./pages/auth/term/term.page"),
            },
        ],
    },
    {
        path: "loading",
        data: { layout: "fullscreen" },
        loadComponent: () => import("./pages/loading/loading.page"),
    },
    {
        path: "guide",
        data: { layout: "fullscreen" },
        loadComponent: () => import("./pages/guide/guide.page"),
    },
    {
        path: "login",
        data: { layout: "fullscreen" },
        children: [
            {
                path: "",
                loadComponent: () => import("./pages/auth/login/login.page"),
            },
            {
                path: "form",
                loadComponent: () =>
                    import("./pages/auth/login-form/login-form.page"),
            },
            {
                path: ":provider",
                loadComponent: () => import("./pages/auth/login/login.page"),
            },
        ],
    },
    {
        path: "sign-up",
        data: { layout: "fullscreen" },
        children: [
            {
                path: "",
                loadComponent: () =>
                    import("./pages/auth/sign-up/sign-up.page"),
            },
            {
                path: "create-profile",
                loadComponent: () =>
                    import("./pages/auth/sign-up/create-profile/create-profile.page"),
            },
        ],
    },
    {
        path: "find-email",
        data: { layout: "fullscreen" },
        loadComponent: () => import("./pages/auth/find-email/find-email.page"),
    },
    {
        path: "find-password",
        data: { layout: "fullscreen" },
        loadComponent: () =>
            import("./pages/auth/find-password/find-password.page"),
    },
    {
        path: "document-box/pdf",
        loadComponent: () =>
            import("./pages/development-service/document-box-pdf/document-box-pdf.page"),
    },
    {
        path: "",
        component: LayoutPage,
        children: [
            {
                path: "charge/:type/payment",
                loadComponent: () =>
                    import("./pages/payment/charge-result/charge-result.page"),
            },
            {
                path: "payment",
                loadComponent: () =>
                    import("./pages/payment/form/payment-form.page"),
            },
            {
                path: "schedule",
                canActivate: [AuthGuard],
                data: {
                    layout: "fullscreen",
                },
                loadComponent: () => import("./pages/schedule/schedule.page"),
            },
            {
                path: "growth-center",
                canActivate: [AuthGuard],
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/growth-center/growth-center.page"),
                    },
                ],
            },
            {
                path: "my-child",
                component: MyChildLayout,
                canActivate: [AuthGuard, HasChildGuard],
                children: [
                    {
                        path: "dashboard",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import("./pages/my-child/dashboard/dashboard.page"),
                            },
                        ],
                    },
                    {
                        path: "info",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import("./pages/my-child/info/info.page"),
                            },
                        ],
                    },

                    {
                        path: "diary",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import("./pages/my-child/diary/diary.page"),
                            },
                        ],
                    },
                    {
                        path: "development-service",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import("./pages/development-service/development-service.page"),
                            },
                            {
                                path: ":id",
                                children: [
                                    {
                                        path: "",
                                        loadComponent: () =>
                                            import("./pages/development-service/detail-development-service/detail-development-service.page"),
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "history",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import("./pages/my-child/history/history.page"),
                            },
                            {
                                path: "form",
                                children: [
                                    {
                                        path: "",
                                        loadComponent: () =>
                                            import("./pages/my-child/history/history-form/history-form.page"),
                                    },
                                    {
                                        path: ":id",
                                        loadComponent: () =>
                                            import("./pages/my-child/history/history-form/history-form.page"),
                                    },
                                ],
                            },
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import("./pages/my-child/history/history-detail/history-detail.page"),
                            },
                        ],
                    },
                    {
                        path: "",
                        redirectTo: "/my-child/dashboard",
                        pathMatch: "full",
                    },
                ],
            },

            // 대시보드
            {
                path: "dashboard",
                canActivate: [AuthGuard],
                loadComponent: () => import("./pages/dashboard/dashboard.page"),
            },

            // 센터 공지사항
            {
                path: "center-notice",
                canActivate: [AuthGuard],
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/center-notice/center-notice.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import("./pages/center-notice/center-notice-detail/center-notice-detail.page"),
                    },
                ],
            },
            // 소식
            {
                path: "content",
                canActivate: [AuthGuard],
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/content/content.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import("./pages/content/content-detail/content-detail.page"),
                    },
                ],
            },
            // 아동 일지 등록 | 수정
            {
                path: "diary-handle",
                canActivate: [AuthGuard],
                children: [
                    {
                        path: "create",
                        loadComponent: () =>
                            import("./pages/my-child/diary/create-diary/create-diary.page"),
                    },
                    {
                        path: "update/:id",
                        loadComponent: () =>
                            import("./pages/my-child/diary/create-diary/create-diary.page"),
                    },
                ],
            },

            {
                path: "update",
                canActivate: [AuthGuard],
                children: [
                    {
                        path: "selected-child",
                        children: [
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import("./pages/find-child/child-form/child-form.page"),
                            },
                        ],
                    },
                ],
            },
            // 아동 찾기 | 등록 | 연결
            {
                path: "find",
                canActivate: [AuthGuard],
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/find-layout/find-layout.page"),
                    },
                    {
                        path: "find-child",
                        loadComponent: () =>
                            import("./pages/find-child/find-child.page"),
                    },
                    {
                        path: "create",
                        loadComponent: () =>
                            import("./pages/find-child/child-form/child-form.page"),
                    },
                    {
                        path: "connect",
                        loadComponent: () =>
                            import("./pages/find-child/connect-child/connect-child.page"),
                    },
                ],
            },
            // 검사 도구
            {
                path: "inspection",
                canActivate: [AuthGuard, HasChildGuard],
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/inspection/inspection.page"),
                    },
                    {
                        path: "intro",
                        loadComponent: () =>
                            import("./pages/inspection/intro/intro.page"),
                    },
                    {
                        path: "payment",
                        loadComponent: () =>
                            import("./pages/inspection/payment-progress/payment-progress.page"),
                    },
                ],
            },

            {
                path: "my-page",
                canActivate: [AuthGuard],
                children: [
                    {
                        path: "",
                        component: MyPageLayoutPage,
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import("./pages/my-page/my-page.page"),
                            },
                        ],
                    },
                    {
                        path: "purchase",
                        loadComponent: () =>
                            import("./pages/my-page/purchase/purchase.page"),
                    },
                    {
                        path: "update-profile",
                        loadComponent: () =>
                            import("./pages/my-page/update-profile/update-profile.page"),
                    },
                    {
                        path: "update-password",
                        loadComponent: () =>
                            import("./pages/my-page/update-password/update-password.page"),
                    },
                    {
                        path: "withdraw",
                        loadComponent: () =>
                            import("./pages/my-page/withdraw/withdraw.page"),
                    },
                    {
                        path: "update-email",
                        loadComponent: () =>
                            import("./pages/my-page/update-email/update-email.page"),
                    },
                    {
                        path: "update-contact",
                        loadComponent: () =>
                            import("./pages/my-page/update-contact/update-contact.page"),
                    },
                    {
                        path: "payment",
                        children: [
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import("./pages/my-page/payment/components/payment-detail/payment-detail.modal"),
                            },
                        ],
                    },
                ],
            },
            {
                path: "customer",
                canActivate: [AuthGuard],
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/customer/customer.page"),
                    },
                    {
                        path: "notice",
                        children: [
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import("./pages/customer/notice/detail-notice/detail-notice.page"),
                            },
                        ],
                    },
                    {
                        path: "inquiry",
                        children: [
                            {
                                path: "create",
                                loadComponent: () =>
                                    import("./pages/customer/inquiry/create-inquiry/create-inquiry.page"),
                            },
                            {
                                path: "update",
                                children: [
                                    {
                                        path: ":id",
                                        loadComponent: () =>
                                            import("./pages/customer/inquiry/create-inquiry/create-inquiry.page"),
                                    },
                                ],
                            },
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import("./pages/customer/inquiry/detail-inquiry/detail-inquiry.page"),
                            },
                        ],
                    },
                ],
            },
            {
                path: "setting",
                canActivate: [AuthGuard],
                children: [
                    {
                        path: "notification",
                        loadComponent: () =>
                            import("./pages/my-page/setting/notification/notification.page"),
                    },
                    {
                        path: "etc",
                        loadComponent: () =>
                            import("./pages/my-page/setting/sound/setting-sound.page"),
                    },
                    {
                        path: "term",
                        loadComponent: () =>
                            import("./pages/my-page/setting/terms/setting-terms.page"),
                    },
                    {
                        path: "history",
                        loadComponent: () =>
                            import("./pages/my-page/setting/history/setting-history.page"),
                    },
                ],
            },
            {
                path: "notification",
                loadComponent: () =>
                    import("./pages/my-page/notification/notification.page"),
            },

            {
                path: "shopping-cart",
                loadComponent: () =>
                    import("./pages/shopping-cart/shopping-cart.page"),
            },
            {
                path: "product/payment/:result",
                loadComponent: () =>
                    import("./pages/payment/result/payment-result.page"),
            },
            {
                path: "store",
                title: `스토어`,
                children: [
                    {
                        path: "",
                        loadComponent: () => import("./pages/store/store.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import("./pages/store/product-detail/product-detail.page"),
                    },
                ],
            },
        ],
    },
];
